import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from './useAuth';

const LogoutIcon = FaSignOutAlt as unknown as React.FC<{ className?: string }>;

function getInitials(name: string): string {
  return name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

function useIsNarrow(breakpoint: number) {
  const [isNarrow, setIsNarrow] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => setIsNarrow(window.innerWidth <= breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isNarrow;
}

function Navbar() {
  const { user, checked, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const isNarrow = useIsNarrow(630);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await logout();
    window.location.href = '/';
  };

  return (
    <nav className="navbar">
      <Link to="/">
        <img
          src="/Galldris-Logo-White-Yellow.png"
          alt="Galldris"
          className="navbar-logo"
        />
      </Link>

      {checked && user && (
        <div className="navbar-links">
          {!isNarrow && (
            <>
              <Link to="/import" className="navbar-link">Bulk Import</Link>
              <Link to="/admin/users" className="navbar-link">Users</Link>
              <Link to="/admin/audit-log" className="navbar-link">Audit Log</Link>
            </>
          )}

          <div className="user-menu" ref={menuRef}>
            <button className="user-pill" onClick={() => setMenuOpen((open) => !open)}>
              <span className="user-pill-name">{user.name}</span>
              <span className="user-pill-avatar">{getInitials(user.name)}</span>
            </button>

            {menuOpen && (
              <div className="user-drawer">
                {isNarrow && (
                  <>
                    <Link to="/import" className="user-drawer-item" onClick={() => setMenuOpen(false)}>
                      Bulk Import
                    </Link>
                    <Link to="/admin/users" className="user-drawer-item" onClick={() => setMenuOpen(false)}>
                      Users
                    </Link>
                    <Link to="/admin/audit-log" className="user-drawer-item" onClick={() => setMenuOpen(false)}>
                      Audit Log
                    </Link>
                    <div className="user-drawer-divider" />
                  </>
                )}
                <button className="user-drawer-item" onClick={handleLogout}>
                  <LogoutIcon /> Log Out
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;